import { Suspense, lazy } from "react";

import { Skeleton } from "@/components/ui/skeleton";

import type { RichTextEditorProps } from "./types";

export { isEmptyHtml } from "./is-empty-html";
export type { RichTextEditorProps } from "./types";

/**
 * Boy matn muharriri.
 *
 * `lazy` — Quill (~200 KB) va uning CSS'i faqat muharrir chizilganda
 * yuklansin: panelga kirgan odamning ko'pchiligi unga umuman tegmaydi.
 */
const QuillEditor = lazy(() => import("./editor"));

export const RichTextEditor = (props: RichTextEditorProps) => (
  <Suspense fallback={<Skeleton className="h-48 w-full rounded-xl" />}>
    <QuillEditor {...props} />
  </Suspense>
);
